import { render, staticRenderFns } from "./MainRouteKeepAlive.vue?vue&type=template&id=2c2e9888"
import script from "./MainRouteKeepAlive.vue?vue&type=script&lang=js"
export * from "./MainRouteKeepAlive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports